
import { message } from "antd";
import api from "./axios";

// ---------------------------------------------------------------------------
// Reads: no toasts here on purpose (would be noisy on every list refresh).
// Fetch errors are toasted in the hooks instead. Mutations (create/update/
// delete) DO toast here, since this is the single place every caller goes
// through, regardless of which screen triggered it.
// ---------------------------------------------------------------------------

// export const getProjects = async () => {
//   const response = await api.get("/projects/");
//   return response.data;
// };
// api/projectApi.js
export const getProjects = async (params = {}) => {
  const response = await api.get("/projects/", { 
    params 
  });
  return response.data;
};
export const getProjectById = async (id) => {
  const response = await api.get(`/projects/${id}/`);
  return response.data;
};

export const getProjectTracking = async (id) => {
  const response = await api.get(`/tracking/project-progress/${id}/`);
  return response.data;
};

  export const getEmployeeProjects = async ({
    district,
    zone,          // ← Keep this (as per your API)
    zone_name,     // ← Also accept zone_name for compatibility
    project_status,
    search,
    page = 1,
    page_size = 9,
  }) => {
    const params = new URLSearchParams();

    if (district && district !== "All") params.append("district", district);
    
    // Support both 'zone' and 'zone_name' (flexible)
    const zoneValue = zone || zone_name;
    if (zoneValue && zoneValue !== "All") {
      params.append("zone", zoneValue);   // Backend expects 'zone'
    }

    if (project_status && project_status !== "All") {
      params.append("project_status", project_status);
    }
    if (search?.trim()) params.append("search", search.trim());

    params.append("page", page);
    params.append("page_size", page_size);

    const response = await api.get(`/projects/?${params.toString()}`);
    return response.data;
  };


export const updateProject = async (id, data) => {
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    if (key === "image") {
      const fileList = Array.isArray(value) ? value : [];

      if (fileList.length === 0) {
        // explicit clear signal for the backend
        formData.append("image", "");
      } else if (fileList[0]?.originFileObj) {
        formData.append("image", fileList[0].originFileObj);
      }
      // else: existing, untouched image -> don't send, leave it as-is
      return;
    }

    if (value !== undefined && value !== null) {
      formData.append(key, value);
    }
  });

  try {
    const response = await api.patch(`/projects/${id}/`, formData);
    message.success("Project details saved");
    return response.data;
  } catch (error) {
    message.error(
      error?.response?.data?.detail || "Failed to save project details"
    );
    throw error;
  }
};

export const updateTracking = async (id, data) => {
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(key, value);
    }
  });

  try {
    const response = await api.patch(
      `/tracking/project-progress/${id}/`,
      formData
    );
    message.success("Progress saved");
    return response.data;
  } catch (error) {
    message.error(
      error?.response?.data?.detail || "Failed to save progress"
    );
    throw error;
  }
};

export const createProject = async (formData) => {
  try {
    const response = await api.post("/projects/", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    message.success("Project created");
    return response.data;
  } catch (error) {
    message.error(error?.response?.data?.detail || "Failed to create project");
    throw error;
  }
};

export const deleteProject = async (id) => {
  try {
    const response = await api.delete(`/projects/${id}/`);
    message.success("Project deleted");
    return response.data; // empty for 204
  } catch (error) {
    message.error(error?.response?.data?.detail || "Failed to delete project");
    throw error;
  }
};

export const getOrgHierarchy = async () => {
  const response = await api.get("/projects/metadata/org-hierarchy/");
  return response.data;
};